<template>
  <div style="padding: 0 1rem">
    <b-row style="min-height: calc(100vh - 40px)">
      <b-col sm="12" lg="8" style="display: flex">
        <div class="center">
          <b-row style="margin-top: -50px">
            <b-col>
              <h1 style="font-weight: 800 !important" class="text-manrope">
                Indonesia Data Hub <span class="underline">(INDAH)</span>
              </h1>
              <p
                class="text-15 text-manrope text-medium text-600"
                style="
                  padding-bottom: 2rem;
                  letter-spacing: 0.4px;
                  margin-top: -20px;
                "
              >
                Indonesia Data Hub merupakan
                <i>one stop collaboration platform</i> yang bertujuan untuk
                meningkatkan literasi data dan <i>value of statistics</i>
                serta mendukung interoperabilitas data dan kolaborasi eksplorasi
                terhadap data.
              </p>
            </b-col>
          </b-row>
          <b-row style="padding-top: 1.5rem">
            <b-col>
              <b-card
                style="cursor: pointer"
                class="text-center mt-2"
                @click="$router.push('/standar-data-statistik')"
              >
                <b-img
                  style="width: 80px"
                  src="./img/application/standar-data.svg"
                  alt="Standar Data Statistik"
                ></b-img>
                <p style="font-weight: 500" class="mt-2 text-manrope text-13">
                  Standar Data Statistik
                </p>
              </b-card>
            </b-col>
            <b-col>
              <b-card
                style="cursor: pointer"
                class="text-center mt-2"
                @click="$router.push('/metadata')"
              >
                <b-img
                  style="width: 80px"
                  src="./img/application/metadata.svg"
                  alt="Metadata Statistik"
                ></b-img>
                <p style="font-weight: 500" class="mt-2 text-manrope text-13">
                  Metadata Statistik
                </p>
              </b-card>
            </b-col>
            <b-col>
              <b-card
                style="cursor: pointer"
                class="text-center mt-2"
                @click="$router.push('/sshi')"
              >
                <b-img
                  style="width: 55px"
                  src="./img/sshi/sshi.png"
                  alt="Statistik Hayati Indonesia"
                ></b-img>
                <p style="font-weight: 500" class="mt-2 text-manrope text-13">
                  Sistem Statistik Hayati Indonesia
                </p>
              </b-card>
            </b-col>
            <b-col cols="2"></b-col>
          </b-row>
        </div>
      </b-col>
      <b-col class="bg" sm="12" lg="4"> </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "HalamanAwal",
  data: () => {
    return {
      query: "",
    };
  },
  methods: {
    cari: function (e) {
      if (e.keyCode === 13) {
        this.search();
      }
    },
    search() {
      this.$router.push("/enterprise-search?query=" + this.query);
    },
  },
};
</script>
